import React from 'react';
import { ArrowUpRightIcon } from 'lucide-react';
import { bookingLabel, links } from '../data/site';
import { trackBookingClick } from '../utils/analytics';
import type { BookingLocation } from '../utils/analytics';
type BookingButtonProps = {
  location: BookingLocation;
  variant?: 'primary' | 'onDark' | 'link';
  size?: 'sm' | 'md';
  className?: string;
};
export function BookingButton({
  location,
  variant = 'primary',
  size = 'md',
  className = ''
}: BookingButtonProps) {
  const base = 'inline-flex items-center justify-center text-center leading-snug transition-colors duration-200';
  const sizes = {
    sm: 'text-sm px-4 py-2.5 rounded-md',
    md: 'text-[0.9375rem] sm:text-base px-5 sm:px-6 py-3.5 rounded-md'
  };
  const variants = {
    primary: `${base} ${sizes[size]} font-medium bg-forest text-paper hover:bg-forest-soft`,
    onDark: `${base} ${sizes[size]} font-medium bg-paper text-forest hover:bg-sage-deep`,
    link: `${base} gap-1.5 font-medium text-forest border-b border-forest/30 hover:border-forest pb-0.5`
  };
  return <a href={links.booking} target="_blank" rel="noopener noreferrer" onClick={() => trackBookingClick(location)} className={`${variants[variant]} ${className}`} data-id="element-21" data-mp="27aba7homyvmy">
      {bookingLabel}
      {variant === 'link' && <ArrowUpRightIcon size={16} aria-hidden="true" data-id="element-22" data-mp="2c7bf3p9r1sch" />}
      <span className="sr-only" data-id="element-23" data-mp="2c9xn1q0jy9v8"> (opens in a new tab)</span>
    </a>;
}